import { useQuery, gql } from "@apollo/client";

import { Building, InventoryRecord } from "gqlTypes";

import cardFragment from "./cardFragment";
import { getFragmentName } from "utils/query";

const QUERY = gql`
  query Building($id: ID!) {
    building(id: $id) {
      isVerified
      ...${getFragmentName(cardFragment)}
    }
  }
  ${cardFragment}
`;

type ResultsType = {
  building: Building | InventoryRecord;
};

const useCardQuery = (id: string) => {
  const { data, ...status } = useQuery<ResultsType>(QUERY, { variables: { id } });

  if (status.error) throw status.error;

  const building = data && data.building;

  return [building, status] as const;
};

export default useCardQuery;
